import { render, staticRenderFns } from "./SideBarPatient.vue?vue&type=template&id=b8f050d8&scoped=true&"
import script from "./SideBarPatient.vue?vue&type=script&lang=ts&"
export * from "./SideBarPatient.vue?vue&type=script&lang=ts&"
import style0 from "./SideBarPatient.vue?vue&type=style&index=0&id=b8f050d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8f050d8",
  null
  
)

export default component.exports